import { Col, Row } from 'react-bootstrap';

//import ProjectElevenProgress from 'components/modules/project-management/dashboard/ProjectElevenProgress';
import ProjectDashboard from 'components/modules/project-management/dashboard/ProjectDashboard';
//import ProjectActivityCard from 'components/cards/ProjectActivityCard';
import { useNavigate } from 'react-router-dom';
import { UserContext } from 'contexts/UserContext';
import { useContext, useEffect } from 'react';

const ProjectManagement = () => {
  const navigate = useNavigate();
  const context = useContext(UserContext);
  useEffect(() => {
    if (!context || !context.user) {
      navigate('/pages/authentication/split/sign-in');
    }
  }, []);

  return (
    <>
      <Row className="gy-3 mb-6 justify-content-between">
        <Col md={9} xs="auto">
          <h2 className="mb-2 text-1100">Projects Dashboard</h2>
          <h5 className="text-700 fw-semi-bold">
            How your pitches are doing right now
          </h5>
        </Col>
      </Row>
      <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-white pt-6 border-top border-300">
        <ProjectDashboard />
      </div>
    </>
  );
};

export default ProjectManagement;
